import { Box, TextField, Typography } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import enLocale from 'date-fns/locale/en-GB';

const CheckInRange = ({ startDate, setStartDate, endDate, setEndDate }) => {
   const addDays = (date, days) => {
      if (!date) return null;
      const result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
   };

   return (
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enLocale}>
         <Box display="flex" gap={2} sx={{ flexDirection: 'column', mb: 2 }}>
            <Typography variant="subtitle2" gutterBottom>
               Date range
            </Typography>
            <DatePicker
               label="Start Date"
               value={startDate}
               onChange={(newValue) => setStartDate(newValue)}
               // No min/max for start date unless endDate is set
               maxDate={endDate ? addDays(endDate, 0) : undefined}
               minDate={endDate ? addDays(endDate, -14) : undefined}
               renderInput={(params) => <TextField {...params} />}
            />
            <DatePicker
               label="End Date"
               value={endDate}
               onChange={(newValue) => setEndDate(newValue)}
               minDate={startDate ? startDate : undefined}
               maxDate={startDate ? addDays(startDate, 14) : undefined}
               renderInput={(params) => <TextField {...params} />}
            />
            <Typography variant="caption" color="textSecondary">
               Note: The date range between start and end is limited to 14 days.
            </Typography>
         </Box>
      </LocalizationProvider>
   );
};
export default CheckInRange;
